import Service from "lib/models/Service";

export default class ConsultationService extends Service {
  getConsultations(params: SearchParamsConsultation) {
    return this.get(`/consultations`, {
      size: 10,
      isRequestBased: params.isRequestBased ?? 1,
      ordering: params.ordering || "consultation_id",
      isDesc: params.ordering ? params.isDesc : 1,
      ...params,
    });
  }
}
